/** Keep the cover first and the selected variation second, without duplicate photos. */
export const resolveVariationGallery = (images, variation) => {
    const image = variation?.image;
    if (!images.length || !image?.src) return { items: images, index: 0 };
    const matching = images.findIndex((item) => (Number(variation.image_id) > 0 && item.id === Number(variation.image_id))
        || item.src === (image.full_src || image.src));
    if (matching === 0) return { items: images, index: 0 };
    const selected = matching > 0 ? images[matching] : {
        id: Number(variation.image_id) || 0,
        src: image.full_src || image.src,
        width: Number(image.full_src_w || image.src_w),
        height: Number(image.full_src_h || image.src_h),
        previewSrc: image.src,
        previewSrcset: image.srcset || '',
        msrc: image.gallery_thumbnail_src || image.src,
        alt: image.alt || images[0].alt,
        caption: image.caption || '',
    };
    return {
        items: [images[0], selected, ...images.slice(1).filter((item) => item !== selected)],
        index: 1,
    };
};

const isGalleryImage = (image) => image?.src && Number.isFinite(image.width) && image.width > 0
    && Number.isFinite(image.height) && image.height > 0;

/** Keep the selected image and its hero index, including optional editorial details. */
export const prepareLightboxGallery = (images, selectedIndex, extraImage = null) => {
    const selected = extraImage || images[selectedIndex];
    if (!isGalleryImage(selected)) return null; // Keep the full-size link as a fallback.
    const items = images.map((image, galleryIndex) => ({ ...image, galleryIndex })).filter(isGalleryImage);
    let index = items.findIndex((image) => image.src === selected.src);
    if (index < 0) {
        index = items.length;
        items.push({ ...selected, galleryIndex: null });
    }
    return { items, index };
};
